module.exports = __webpack_public_path__ + "static/font-86593d9271859bdab7c4f7288a95cc4a.woff2";